import { render, staticRenderFns } from "./Ondemand.vue?vue&type=template&id=3b2cd98f&"
import script from "./Ondemand.vue?vue&type=script&lang=js&"
export * from "./Ondemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports